// SystemSubsystem.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./SystemSubsystem.css";

import RFPassiveComponents from "../Assessts/ProductsWeDeal/1productRF.jpg";
import FiltersAmplifiersOscillators from "../Assessts/ProductsWeDeal/2filters.jpg";
import ethernetrouter from "../Assessts/ProductsWeDeal/3ethernetrouter.jpg";
import RuggedIndustrialHandheldPDA from "../Assessts/ProductsWeDeal/4pda.jpg";
import MotorsAndBlowers from "../Assessts/ProductsWeDeal/5moters.jpg";
import MicrowaveAmplifiers from "../Assessts/ProductsWeDeal/6amplifier.jpg";
import GIGABITEthernetRecorder from "../Assessts/ProductsWeDeal/7recorder.jpg";
import FlightDataRecorder from "../Assessts/ProductsWeDeal/8fdr.jpg";
import Arinc from "../Assessts/ProductsWeDeal/9arinc.jpg";
import RuggedNotebook from "../Assessts/ProductsWeDeal/10notebook.jpg";
import IndustrialRuggedSolidStateDrive from "../Assessts/ProductsWeDeal/11ssd.jpg";
import ObsoleteComponentsSystemReplacement from "../Assessts/ProductsWeDeal/12obsolete.jpg";
import sensor from "../Assessts/ProductsWeDeal/sensor.jpg";
import ACCELEROMETERSANDGYROSCOPE from "../Assessts/ProductsWeDeal/ACCELEROMETERS AND GYROSCOPE.jpg";
import encoders from "../Assessts/ProductsWeDeal/encoders.jpg";
import connectorandrelays from "../Assessts/ProductsWeDeal/connector and relays.jpg";
import sbc_io from "../Assessts/ProductsWeDeal/sbc_io cards.jpg";
import Converters from "../Assessts/ProductsWeDeal/14convertors.jpg";


//measuring(anristunew)
import SiteMaster820 from "../Assessts/Measuring(anristunew)/1Site_MasterS820.png";
import Site_masterS330 from "../Assessts/Measuring(anristunew)/2Site_masterS330.png";
import LMR_Master_S412E from "../Assessts/Measuring(anristunew)/3LMR_Master_S412E.png";
import FieldMaster2090A from "../Assessts/Measuring(anristunew)/4FieldMaster2090A.png";
import FieldMaster2080A from "../Assessts/Measuring(anristunew)/5FieldMaster2080A.png";
import vectordstar4640B from "../Assessts/Measuring(anristunew)/6vectordstar4640B.png";
import vectorNetworkAnalyzer from "../Assessts/Measuring(anristunew)/7vectorNetworkAnalyzer.png";
import ShockLineMe7869 from "../Assessts/Measuring(anristunew)/8ShockLineMe7869.png";
import Rubidium_signal_generator from "../Assessts/Measuring(anristunew)/9Rubidium_signal_generator.png";
import PIM_Master from "../Assessts/Measuring(anristunew)/10PIM_Master.png";
import VNA_master_MS2036C from "../Assessts/Measuring(anristunew)/11VNA_master_MS2036C.png";
import USB_Power_sensors from "../Assessts/Measuring(anristunew)/12USB_Power_sensors.png";

// ✅ Products array reordered as per your requirement
const products = [
{
    id: 1,
    title: "SENSORS",
    img: sensor,
    desc: "High-precision sensors for aerospace, defense, and industrial applications. Designed for accuracy, durability, and reliability in extreme conditions. Enable real-time monitoring and control of mission-critical systems.",
    list: [
      "Inclination Sensors",
      "Pressure Sensors",
      "Temperature Sensors",
      "Displacement/Distance Measuring Sensors",
      "Motion Sensors",
      "Ultrasonic & Photoelectric Sensors",
      "Speed Sensors",
      "Inductive, Capacitive & Magnetic Sensors",
      "Vision Sensors",
      "Force And Strain Sensors",
      "Limit And Level Switches",
    ],
  },
  {
    id: 2,
    title: "ACCELEROMETERS & GYROSCOPE",
    img: ACCELEROMETERSANDGYROSCOPE,
    desc: "Advanced accelerometers and gyroscopes engineered for navigation, stabilization, and motion detection. Provide precise measurements under high-stress environments. Critical for aircraft, defense vehicles, and space systems.",
  },
  {
    id: 3,
    title: "ENCODERS",
    img: encoders,
    desc: "Rugged encoders that deliver accurate position and motion feedback. Built for aerospace and industrial automation. Ensure reliability in demanding mechanical systems and mission-driven platforms.",
    list: [
      "Incremental and Absolute Encoders",
      "Wire Rope Encoders",
      "Heavy Duty Encoders",
      "Actuators and Positioning Drives",
      "Spindle Positioning Systems",
      "Tachogenerators",
      "Inclinometers",
    ],
  },
  {
    id: 4,
    title: "CONNECTORS & RELAYS",
    img: connectorandrelays,
    desc: "Robust connectors and relays ensuring secure electrical and signal connections. Resistant to vibration, shock, and environmental stress. Trusted for aerospace, defense, and critical communication systems.",
    list: [
      "Twisted – Pair connectors",
      "Coaxial cable connectors",
      "Fiber–optic connectors",
      "Latching Relays",
      "Reed Relays",
      "Polarized Relays",
      "IDMT Relays Differential Relays",
    ],
  },
  {
    id: 5,
    title: "SBC & I/O MODULES",
    img: sbc_io,
    desc: "Single Board Computers (SBC) and I/O modules designed for rugged embedded applications. Deliver high performance, reliability, and scalability. Ideal for avionics, defense electronics, and industrial automation.",
  },
  {
    id: 6,
    title: "RF PASSIVE COMPONENTS",
    img: RFPassiveComponents,
    desc: "Precision RF passive components engineered for aerospace and defense environments. Our solutions ensure minimal signal loss and maximum reliability. Designed to withstand harsh conditions, they deliver consistent performance in mission-critical systems.",
  },
  {
    id: 7,
    title: "FILTERS, AMPLIFIERS & OSCILLATORS",
    img: FiltersAmplifiersOscillators,
    desc: "High-performance filters, amplifiers, and oscillators tailored for communication systems. Built for accuracy, low noise, and efficiency. These components provide robust signal processing for both ground and airborne platforms.",
  },
  {
    id: 8,
    title: "ETHERNET ROUTERS",
    img: ethernetrouter,
    desc: "Rugged Ethernet routers designed for secure, high-speed data communication. Optimized for demanding military and industrial networks. Reliable connectivity ensures smooth operation even in extreme field conditions.",
  },
  {
    id: 9,
    title: "RUGGED INDUSTRIAL HANDHELD PDA",
    img: RuggedIndustrialHandheldPDA,
    desc: "Durable handheld PDAs built for mission-critical field operations. Withstand shock, dust, and extreme weather while delivering powerful computing. Ideal for defense, aerospace, and industrial workforce mobility.",
  },
  {
    id: 10,
    title: "MOTORS & BLOWERS",
    img: MotorsAndBlowers,
    desc: "Reliable motors and blowers engineered for aerospace and industrial use. Designed for efficiency, durability, and quiet operation. Supporting cooling, propulsion, and mechanical systems in sensitive environments.",
  },
  {
    id: 11,
    title: "MICROWAVE AMPLIFIERS",
    img: MicrowaveAmplifiers,
    desc: "High-power microwave amplifiers supporting radar, communication, and defense applications. Built with advanced thermal management for long service life. Delivering stable gain and low distortion under extreme loads.",
  },
  {
    id: 12,
    title: "GIGABIT ETHERNET RECORDER",
    img: GIGABITEthernetRecorder,
    desc: "High-speed Ethernet data recorders with rugged construction for harsh deployments. Capable of capturing large volumes of mission data without interruption. Trusted in aerospace, defense, and industrial test setups.",
  },
  {
    id: 13,
    title: "FLIGHT DATA RECORDER",
    img: FlightDataRecorder,
    desc: "Black box flight data recorders ensuring secure and reliable storage. Built to survive impact, fire, and extreme conditions. Complies with aviation standards for safety and post-event analysis.",
  },
  {
    id: 14,
    title: "ARINC SYSTEMS",
    img: Arinc,
    desc: "ARINC-compliant avionics systems for reliable aircraft communication. Designed for interoperability and precision in mission-critical platforms. Supporting modern and legacy fleets with long-term sustainability.",
  },
  {
    id: 15,
    title: "RUGGED NOTEBOOK",
    img: RuggedNotebook,
    desc: "Military-grade rugged notebooks designed for extreme field operations. Withstand shock, vibration, dust, and temperature extremes. Equipped with advanced hardware to support demanding applications anywhere.",
  },
  {
    id: 16,
    title: "INDUSTRIAL RUGGED SOLID STATE DRIVE",
    img: IndustrialRuggedSolidStateDrive,
    desc: "Durable SSDs built for defense and industrial use. Shockproof, vibration-resistant, and optimized for speed. Provide reliable data storage where traditional drives fail under harsh conditions.",
  },
  {
    id: 17,
    title: "OBSOLETE COMPONENTS",
    img: ObsoleteComponentsSystemReplacement,
    desc: "Replacement solutions for obsolete components in legacy systems. Extending the life of critical infrastructure by sourcing or designing alternatives. Prevent downtime and reduce upgrade costs significantly.",
  },
  {
    id: 18,
    title: "CONVERTERS",
    img: Converters,
    desc: "Custom RF and power converters tailored for aerospace and defense systems. Provide efficient conversion with minimal loss. Built to meet rigorous standards for safety, reliability, and long-term operation.",
  },
  {
  id: 19,
  title: "Site Master S820",
  img: SiteMaster820,
  desc: "The Site Master S820 is a portable microwave/RF cable and antenna analyzer designed for field use. It provides fast and accurate measurements across a wide frequency range. Built with rugged durability, it ensures reliable performance in challenging environments. Engineers use it extensively for network maintenance and troubleshooting."
},
{
  id: 20,
  title: "Site Master S330",
  img: Site_masterS330,
  desc: "The Site Master S330 is a versatile handheld cable and antenna analyzer. It offers high precision in detecting faults in transmission lines and antenna systems. Its user-friendly interface makes it easy to operate for technicians in the field. This device enhances efficiency in RF system validation and maintenance."
},
{
  id: 21,
  title: "LMR Master S412E",
  img: LMR_Master_S412E,
  desc: "The LMR Master S412E is an advanced handheld analyzer for Land Mobile Radio (LMR) systems. It combines spectrum analysis, interference analysis, and coverage mapping in one unit. The device is highly valued for mission-critical communication systems testing. Its portability and accuracy make it ideal for field operations."
},
{
  id: 22,
  title: "Field Master 2090A",
  img: FieldMaster2090A,
  desc: "The Field Master 2090A is a high-performance real-time spectrum analyzer. It provides exceptional dynamic range and frequency coverage for demanding RF applications. With advanced measurement capabilities, it helps in identifying interference and signal issues. It is widely used for both laboratory and outdoor testing scenarios."
},
{
  id: 23,
  title: "Field Master 2080A",
  img: FieldMaster2080A,
  desc: "The Field Master 2080A is a compact spectrum analyzer for wide-frequency applications. It offers high-speed measurements with excellent accuracy and stability. Ideal for detecting signal interference, it supports real-time monitoring. Its rugged design ensures suitability for both field and lab environments."
},
{
  id: 24,
  title: "VectorStar 4640B",
  img: vectordstar4640B,
  desc: "The VectorStar 4640B is a cutting-edge vector network analyzer (VNA). It provides superior accuracy and measurement speed across a broad frequency range. Engineers use it for characterizing RF and microwave components. Its advanced features support high-end research and development projects."
},
{
  id: 25,
  title: "Vector Network Analyzer",
  img: vectorNetworkAnalyzer,
  desc: "The Vector Network Analyzer is a fundamental tool for RF testing. It measures complex impedance, gain, and phase characteristics of networks and devices. Engineers rely on it for precision component analysis and design validation. It ensures optimized performance of RF and microwave systems."
},
{
  id: 26,
  title: "ShockLine ME7869",
  img: ShockLineMe7869,
  desc: "The ShockLine ME7869 is a modular VNA system designed for high-frequency testing. It enables accurate measurements up to millimeter-wave frequencies. Its compact architecture makes it cost-effective without compromising precision. Used in 5G, satellite, and high-frequency component testing industries."
},
{
  id: 27,
  title: "Rubidium Signal Generator",
  img: Rubidium_signal_generator,
  desc: "The Rubidium Signal Generator delivers highly stable and accurate signal outputs. Its rubidium atomic clock ensures exceptional frequency stability. This device is widely used in calibration, testing, and synchronization. It is critical for advanced communications and aerospace applications."
},
{
  id: 28,
  title: "PIM Master",
  img: PIM_Master,
  desc: "The PIM Master is a field analyzer for Passive Intermodulation (PIM) testing. It identifies interference caused by nonlinear components in RF systems. Technicians use it for maintaining cellular base stations and antennas. Its rugged portability makes it suitable for real-world field deployments."
},
{
  id: 29,
  title: "VNA Master MS2036C",
  img: VNA_master_MS2036C,
  desc: "The VNA Master MS2036C is a compact vector network analyzer for field applications. It combines spectrum analysis, cable and antenna testing, and VNA functions in one device. With a wide frequency range, it delivers precise measurements for RF systems. Its rugged design makes it ideal for outdoor and remote operations."
},
{
  id: 30,
  title: "USB Power Sensors",
  img: USB_Power_sensors,
  desc: "USB Power Sensors provide accurate RF power measurements in a portable format. They connect directly to a laptop or PC via USB, eliminating the need for bulky instruments. Engineers use them for fast, efficient testing in lab and field environments. Their compact size and reliability make them highly versatile for RF power monitoring."
}

];


export default function ProductsWeDeal() {
  return (
    <div
      style={{
        background:
          // "linear-gradient(135deg, rgba(28, 29, 31, 0.95), rgba(255, 255, 255, 0.9))",
          "white"
      }}
    >
      <h2
        style={{
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "50px",
          paddingTop: "50px",
          color: "white",
        }}
      >
        {/* TRENDING <span>↗</span> */}
        PRODUCT WE DEAL
      </h2>
      <div className="system-grid">
        {products.map((item) => (
          <div className="system-card" key={item.id}>
            <img
              src={item.img}
              alt={item.title}
              style={{ height: "250px", objectFit: "contain" }}
            />
            <div className="card-title">{item.title}</div>

            {/* description overlay appears only on hover */}
            <div className="hover-desc">
              <p>{item.desc}</p>
              <Link
                to={`/viewproductwe/${item.id}`}
                className="view-product-btn"
              >
                View Product
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { products }; // export products so ProductDetails can use
